import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import { GET_GOLF_COURSE_FORMATS_BY_ID, GET_GOLF_COURSE_FORMATS_BY_ID_SUCCESS, GET_GOLF_COURSE_FORMATS_BY_ID_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getGolfCourseFormatsById({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourse-format/${payload?.urlParam?.id}`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_GOLF_COURSE_FORMATS_BY_ID_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GOLF_COURSE_FORMATS_BY_ID_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GOLF_COURSE_FORMATS_BY_ID_ERROR, payload: error });
  }
}

export function* watchGetGolfCourseFormatsById() {
  yield takeEvery(GET_GOLF_COURSE_FORMATS_BY_ID, getGolfCourseFormatsById);
}

function* getGolfCourseFormatsByIdSaga() {
  yield all([fork(watchGetGolfCourseFormatsById)]);
}

export default getGolfCourseFormatsByIdSaga;
